import axiosInstance from '../api/axiosInstance';

// FormData.append her değeri metne çevirir; null/undefined "null"/"undefined" olarak gider.
// Bu yüzden dolu olmayan alanı hiç eklemiyoruz.
const appendIfPresent = (formData, key, value) => {
  if (value === null || value === undefined) return;
  const text = String(value).trim();
  if (!text || text === 'null' || text === 'undefined') return;
  formData.append(key, text);
};

const ENDPOINTS = {
  GET_ALL_USERS: '/GetAllUser',
  GET_ALL_PERSONEL_USERS: '/GetAllPerosnelUser',
  GET_ALL_ROLES: '/GetAllRoles',
  CREATE_USER: '/CreateUser',
  DELETE_USER: '/UserDelete',
  UPDATE_USER: '/UpdateUser'
};

export const getAllRoles = async () => {
  try {
    const response = await axiosInstance.get(ENDPOINTS.GET_ALL_ROLES);
    const data = response.data;
    if (Array.isArray(data)) {
      return data;
    }
    if (data?.data && Array.isArray(data.data)) {
      return data.data;
    }
    return [];
  } catch (error) {
    console.error('Failed to fetch roles:', error);
    throw error;
  }
};

export const getAllUsers = async () => {
  try {
    const response = await axiosInstance.get(ENDPOINTS.GET_ALL_USERS);
    if (response.data && response.data.status === 200) {
      const users = response.data.data;
      // Ensure we have an array and filter only active users
      if (Array.isArray(users)) {
        return users;
      }
    }
    return [];
  } catch (error) {
    console.error('Failed to fetch users:', error);
    throw error;
  }
};
export const getuserTask = async ({ planid} = {}) => {
  const url = `/TaskExport/`+planid;
  const response = await axiosInstance.get(url, {
    responseType: "blob",
  });

  if (response.status !== 200) {
    throw new Error("Rapor indirme işlemi başarısız oldu");
  }

  return response;
};
export const getAllPersonelUsers = async () => {
  try {
    const response = await axiosInstance.get(ENDPOINTS.GET_ALL_PERSONEL_USERS);
    if (response.data && response.data.status === 200) {
      const users = response.data.data;
      // Ensure we have an array and filter only active users
      if (Array.isArray(users)) {
        return users;
      }
    }
    return [];
  } catch (error) {
    console.error('Failed to fetch users:', error);
    throw error;
  }
};

export const createUser = async (userData) => {
  try {
    const formData = new FormData();
    formData.append('Name', userData.name);
    formData.append('Surname', userData.surname);
    formData.append('Tcnumber', userData.tcnumber);
    formData.append('PhoneNumber', userData.phoneNumber);
    formData.append('Role', userData.role);
    formData.append('IsActive', userData.isActive);
    appendIfPresent(formData, 'Email', userData.email);
    appendIfPresent(formData, 'Grup', userData.grup);
    appendIfPresent(formData, 'Ilce', userData.ilce);
    appendIfPresent(formData, 'Mahlist', userData.mahlist);
    const response = await axiosInstance.post(ENDPOINTS.CREATE_USER, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    if (response.data && response.data.status === 200) {
      return response.data;
    }
    throw new Error(response.data.message || 'Failed to create user');
  } catch (error) {
    console.error('Create user error:', error);
    throw error;
  }
};

export const deleteUser = async (userId) => {
  try {
    const response = await axiosInstance.delete(`${ENDPOINTS.DELETE_USER}/${userId}`);
    if (response.data && response.data.status === 200) {
      return response.data;
    }
    throw new Error(response.data.message || 'Failed to deactivate user');
  } catch (error) {
    console.error('User deactivation error:', error);
    throw error;
  }
};

export const updateUser = async (userId, userData) => {
  try {
    const formData = new FormData();
    formData.append('Name', userData.name);
    formData.append('Surname', userData.surname);
    formData.append('Tcnumber', userData.tcnumber);
    formData.append('PhoneNumber', userData.phoneNumber);
    formData.append('Role', userData.role);
    formData.append('IsActive', userData.isActive);
    formData.append('pass', ''); // Empty password as shown in the example
    // Boş alanlar hiç gönderilmez: FormData null/undefined değerleri "null"/"undefined"
    // METNİNE çevirir ve backend bunu gerçek değer sanıp yazar. E-postada bu, kullanıcının
    // guzel/diğer ayrımının yanlış tarafına düşüp listeden kaybolması demek.
    appendIfPresent(formData, 'Email', userData.email);
    appendIfPresent(formData, 'Grup', userData.grup);
    appendIfPresent(formData, 'Ilce', userData.ilce);
    appendIfPresent(formData, 'Mahlist', userData.mahlist);

    const response = await axiosInstance.put(`${ENDPOINTS.UPDATE_USER}/${userId}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    if (response.data && response.data.status === 200) {
      return response.data;
    }
    throw new Error(response.data.message || 'Failed to update user');
  } catch (error) {
    console.error('Update user error:', error);
    throw error;
  }
}; 